import React, { useState } from "react"
import { Container, Row, Col } from "react-bootstrap"
import { ProjectCard, Slideshow } from "./components"
import { Particles } from "components"
import localization from "utils/localization"
import PROJECTS from 'constants/projects'

function Projects() {
    const [slideshow, setSlideshow] = useState(null)

    return (
        <Container fluid className="project-section">
            <Particles />
            <Slideshow images={ slideshow } onClose={ () => setSlideshow(null) } />
            <Container>
                <h1 className="project-heading">
                    { localization('my3') } <strong className="purple">{ localization('projects', true)}</strong>
                </h1>
                <p style={{ color: "white" }}>
                    { localization('projects-desc') }
                </p>
                <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
                    { PROJECTS.map(pj => (
                        <Col key={ pj.title } md={ 4 } className="project-card">
                            <ProjectCard image={ pj.image } title={ pj.title } tools={ pj.tools } link={ pj.link }
                                onViewSlide={ pj.slideshow ? () => setSlideshow(pj.slideshow) : null }
                            >
                                { pj.description }
                            </ProjectCard>
                        </Col>
                    ))}
                </Row>
            </Container>
        </Container>
    )
}

export default Projects